export const REQUEST_MESSAGE_CONSTANTS = {
  // Title
  TITLE_USER_REQUEST: 'TITLE.USER_REQUEST_TITLE',

  // Success Approve
  SUCCESS_PENDING_BUSINESS_USER_APPROVE: 'SUCCESS.PENDING_BUSINESS_USER_APPROVE',

  // Success Reject
  SUCCESS_PENDING_BUSINESS_USER_REJECT: 'SUCCESS.PENDING_BUSINESS_USER_REJECT',


  TITLE_LEAVE_REQUEST: 'TITLE.LEAVE_REQUEST',

  // Success Approve
  SUCCESS_LEAVE_APPROVE: 'SUCCESS.LEAVE_APPROVE',

  // Success Reject
  SUCCESS_LEAVE_REJECT: 'SUCCESS.LEAVE_REJECT',


};
